var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerateBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66675 17.092V7.38311C3.66675 4.76694 3.66675 3.45885 4.4722 2.64612C5.27766 1.83337 6.57402 1.83337 9.16675 1.83337H12.8334C15.4261 1.83337 16.7225 1.83337 17.5279 2.64612C18.3334 3.45885 18.3334 4.76694 18.3334 7.38311V17.092C18.3334 18.4777 18.3334 19.1706 17.9099 19.4433C17.2179 19.889 16.1482 18.9543 15.6101 18.6151C15.1655 18.3347 14.9433 18.1945 14.6965 18.1864C14.43 18.1776 14.2037 18.3121 13.7234 18.6151L11.9717 19.7197C11.4992 20.0177 11.263 20.1667 11.0001 20.1667C10.7372 20.1667 10.501 20.0177 10.0284 19.7197L8.27678 18.6151C7.83222 18.3347 7.60994 18.1945 7.36323 18.1864C7.09666 18.1776 6.87043 18.3121 6.39005 18.6151C5.85204 18.9543 4.78221 19.889 4.0902 19.4433C3.66675 19.1706 3.66675 18.4777 3.66675 17.092Z",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 10.0834H7.33325",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 6.41663H7.33325",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateBill);
export default __webpack_public_path__ + "static/media/generate-bill.85df3964871a1be68bffc103ec77ca04.svg";
export { ForwardRef as ReactComponent };